// Shown when the carrier arrives without a valid link or session. The signed
// link is the only way in, so we point them to their FreightSimple contact
// rather than offering a self-serve sign-in. Styling is raw here (this is App/
// infrastructure, like Hubble's LoginScreen) since there is no Core primitive
// for a full-screen branded splash.
export function CarrierSignedOut() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-light-background">
      <img src="/logo.png" alt="FreightSimple" className="h-14 w-14" />
      <div className="text-xl font-bold text-foreground">Carrier Portal</div>
      <div className="max-w-sm text-center text-sm text-content-secondary">
        Get in touch with your FreightSimple contact for access.
      </div>
    </div>
  );
}
